export default "__VITE_ASSET__C_iMsyI0__"